import { useNavigate } from 'react-router';
import { useWorkOrders } from '@/features/crm/work-orders/hooks';
import { KpiCard } from '@/lib/ui';
import { useCases } from './hooks';

/** Case and field-service KPIs shown on the CRM home page. */
export function CaseKpis() {
  const navigate = useNavigate();
  const cases = useCases('Active');
  const workOrders = useWorkOrders('Open');
  const atRisk = cases.data.filter((c) => c.sla?.atRisk || c.sla?.breached).length;
  const unassigned = cases.data.filter((c) => !c.assignedTo && !c.assignedGroup).length;
  const unscheduled = workOrders.data.filter((w) => !w.assignedTechUid || !w.scheduledStart).length;
  return (
    <>
      <KpiCard label="Open cases" value={cases.data.length} onClick={() => navigate('/crm/cases')} />
      <KpiCard label="Cases at risk / breached" value={atRisk} onClick={() => navigate('/crm/cases')} />
      <KpiCard label="Unassigned cases" value={unassigned} onClick={() => navigate('/crm/cases')} />
      <KpiCard label="Unscheduled work orders" value={unscheduled} onClick={() => navigate('/crm/work-orders')} />
    </>
  );
}
